export default __webpack_public_path__ + "static/media/docs.1b0cdeca.svg";